import React from 'react';
import {useParams} from 'react-router-dom';
import Redirect from './redirect';
import searchFilter from '../utilities/search-filter';

const IMPULSES_QUERY_PARAMS = 'mmImpulsesQueryParams__0';

export const saveImpulseQueryParams = ({impulseId, search}) => {
    if (search && impulseId) {
        let queryParams = JSON.parse(localStorage.getItem(IMPULSES_QUERY_PARAMS)) || [];
        queryParams.push({impulseId, search});
        if (queryParams.length > 3) {
            queryParams = queryParams.slice(-3);
        }
        localStorage.setItem(IMPULSES_QUERY_PARAMS, JSON.stringify(queryParams));
    }
};

const PaymentCallback = () => {
    const {impulseId} = useParams();
    const queryParams = JSON.parse(localStorage.getItem(IMPULSES_QUERY_PARAMS)) || [];
    const foundParamsObject = queryParams.find((e) => e.impulseId === impulseId);
    const foundParams = foundParamsObject ? foundParamsObject.search : '';
    return (
        <Redirect to={`/complete${searchFilter(foundParams, {impulseId})}`} replace/>
    )
}

export default React.memo(PaymentCallback);